// WinnerSelector.jsx - Multi-select dropdown for selecting session winners
// Display-only component - determination logic lives in SessionForm
import React, { useState, useRef, useEffect } from "react";

function WinnerSelector({ 
  participants, 
  winners, 
  setWinners, 
  disabled = false 
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleWinner = (participantId) => {
    if (disabled) return;
    const participantIdStr = String(participantId);
    const winnersAsString = winners.map(String);
    const newWinners = winnersAsString.includes(participantIdStr)
      ? winnersAsString.filter(id => id !== participantIdStr)
      : [...winnersAsString, participantIdStr];
    setWinners(newWinners);
  };

  const removeWinner = (participantId) => {
    if (disabled) return;
    const participantIdStr = String(participantId);
    const winnersAsString = winners.map(String);
    setWinners(winnersAsString.filter(id => id !== participantIdStr));
  };

  const getParticipantName = (participant) => {
    return participant.username || participant.name || 'Unknown';
  };

  const winnersAsString = winners.map(String);
  const selectedWinners = participants.filter(p => winnersAsString.includes(String(p.id)));

  
  
  return (
    <div ref={dropdownRef} style={{ position: "relative", width: "100%" }}>
      {/* Selected winners display */}
      <div style={{
        border: "1px solid var(--border-color, #ddd)",
        borderRadius: "4px",
        padding: "0.5rem",
        minHeight: "40px",
        backgroundColor: disabled ? "var(--bg-tertiary, #f5f5f5)" : "var(--bg-primary, white)",
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        flexWrap: "wrap",
        gap: "0.25rem",
        alignItems: "center"
      }}
      onClick={() => !disabled && setIsOpen(!isOpen)}
    >
      {selectedWinners.length === 0 ? (
        <span style={{ 
          color: "var(--text-secondary, #666)", 
          fontSize: "0.875rem",
          fontStyle: "italic"
        }}>
          No winners (click to select)
        </span>
      ) : (
        selectedWinners.map(participant => (
          <span
            key={participant.id}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
              backgroundColor: "var(--pista-button-bg, #1976d2)",
              color: "white",
              padding: "0.25rem 0.5rem",
              borderRadius: "12px",
              fontSize: "0.75rem",
              cursor: disabled ? "not-allowed" : "pointer"
            }}
            onClick={(e) => {
              e.stopPropagation();
              removeWinner(participant.id);
            }}
          >
            {getParticipantName(participant)}
            {!disabled && (
              <span style={{ marginLeft: "0.25rem", cursor: "pointer" }}>×</span>
            )}
          </span>
        ))
      )}
    </div>

      {/* Dropdown */}
      {isOpen && !disabled && (
        <div style={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          border: "1px solid var(--border-color, #ddd)",
          borderRadius: "4px",
          backgroundColor: "var(--bg-primary, white)",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          maxHeight: "200px",
          overflowY: "auto",
          zIndex: 1000
        }}>
          {participants.map(participant => (
            <div
              key={participant.id}
              style={{
                padding: "0.5rem",
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                cursor: "pointer",
                backgroundColor: winnersAsString.includes(String(participant.id)) 
                  ? "var(--pista-button-bg, #1976d2)" 
                  : "transparent",
                color: winnersAsString.includes(String(participant.id)) ? "white" : "var(--text-primary, #333)"
              }}
              onClick={() => toggleWinner(participant.id)}
              onMouseEnter={(e) => {
                if (!winnersAsString.includes(String(participant.id))) {
                  e.target.style.backgroundColor = "var(--bg-secondary, #f5f5f5)";
                }
              }}
              onMouseLeave={(e) => {
                if (!winnersAsString.includes(String(participant.id))) {
                  e.target.style.backgroundColor = "transparent";
                }
              }}
            >
              <input
                type="checkbox"
                checked={winnersAsString.includes(String(participant.id))}
                onChange={() => {}}
                style={{ margin: 0 }}
                onClick={(e) => e.stopPropagation()}
              />
              <span>{getParticipantName(participant)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default WinnerSelector;
